import { render, staticRenderFns } from "./CurrencySelect.vue?vue&type=template&id=3c9a0ed0&scoped=true"
import script from "./CurrencySelect.vue?vue&type=script&lang=js"
export * from "./CurrencySelect.vue?vue&type=script&lang=js"
import style0 from "./CurrencySelect.vue?vue&type=style&index=0&id=3c9a0ed0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9a0ed0",
  null
  
)

export default component.exports